import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose();

const button = enhance(
  ({ classes, id, onClickAction, btnText = 'メニュー追加' }) => {
    return (
      <Button
        variant="contained"
        color="secondary"
        onClick={() => {
          onClickAction(id);
        }}
        className={classes.button}
      >
        {btnText}
      </Button>
    );
  }
);

export default withRouter(withStyles(styles)(button));
